import React from 'react'
import { ChevronDown } from 'react-feather'
import { Btn, Image, P } from '../../../../../../AbstractElements'
import { dynamicImage } from '../../../../../../Utils'
import InboxOptions from './InboxOptions'
import UserBody from './UserBody'
import UserFooter from './UserFooter'
import { MailPropsType } from '../../../../../../Types/LetterBox.type'
import { LetterDetailResponse } from '../../../../../../Features/letterBox/api/types';

export default function UserMail({ handlePrint, detail, isLoadingDetail }: MailPropsType & { detail: LetterDetailResponse | null; isLoadingDetail: boolean }) {
    const data = detail?.data;
    const fromName = data?.from_name?.trim() || data?.from_email || '';
    const fromEmail = data?.from_email || '';
    const sender = data?.from_name?.trim() && fromEmail ?         `${data.from_name} <${fromEmail}>` : fromName;
    const inboxSecurityData = [
        { id: 'from', text: 'Da: ', span: sender },
        { id: 'to', text: 'A: ', span: data?.to_email },
        { id: 'reply-to', text: 'Rispondi a: ', span: data?.reply_to },
        { id: 'date', text: 'Data: ', span: data?.data_frm || data?.data_ins },
        { id: 'subject', text: 'Oggetto: ', span: data?.subject },
        { id: 'ticket', text: 'Ticket: ', span: data?.ticketID },
    ].filter(item => item.span);



    return (
        <div className="user-mail-wrapper">
            <div className="user-title">
                <div>
                    <div className="rounded-border">
                        <Image className="img-fluid" src={dynamicImage(`user/12.png`)} alt="user" />
                    </div>
                    <div className="dropdown-subtitle">
                        <P>{isLoadingDetail ? "Caricamento..." : data?.subject}</P>
                        {!isLoadingDetail && fromEmail && <P className="mb-0">{fromEmail}</P>}
                        <div className="onhover-dropdown">
                            <Btn color='transparent' className="p-0 dropdown-button"> {'Dettagli email'} <ChevronDown /></Btn>
                            <div className="inbox-security onhover-show-div">
                                {inboxSecurityData.map((item) => (
                                    <P key={item.id}> {item.text} <span>{item.span}</span></P>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-end gap-3 flex-wrap ms-auto">
                    {!isLoadingDetail && data?.ticketID && <strong className="text-primary">{data.ticketID}</strong>}
                    {/* <InboxOptions id={detail?.data?.ID} favourite={detail?.data?.favourite} data_ins={detail?.data?.data_ins} handlePrint={handlePrint} /> */}
                </div>
            </div>
            <UserBody body={detail?.data?.body_text} isLoading={isLoadingDetail} />
            <UserFooter attachments={detail?.attachments ?? []} />
        </div>
    )
}
